
const NHEdit = (props) => {
    if(!Window.react_data.is_editor){
        return null;
    }
    return <div className={props.className}><a className="inline-flex bg-neutral-cloud-500 rounded-full p-2" style={{cursor:"pointer"}} onClick={() => {props.onClick()}}>
        <img src={`${Window.static_path}img/icons/pencil.svg`} style={{width:"24px", height:"24px"}} />
        </a></div>
}

export default NHEdit;